// extracted by mini-css-extract-plugin
export var mcpContractItem = "mcp-contract-item_M76d90tFO32VnxPpRzin";
export var mcpContractItemDetails = "mcp-contract-item__details_dT1z2tmBYwWx4R3avAAu";
export var mcpContractItemDetailsExpanded = "mcp-contract-item__details_expanded_FMfI2vzFkhLed83lVB4p";
export var mcpContractItemExpanded = "mcp-contract-item_expanded_cjl6UjTt__PUKt_9IhSD";
export var mcpContractItemExpandedDetails = "mcp-contract-item__expanded-details_qUJLlTXYfspEAXg2FBLA";
export var mcpContractItemExpired = "mcp-contract-item_expired_sxGW_WcyczyvJn5hVU9_";
export var mcpContractItemHandle = "mcp-contract-item__handle_ntVpYpzMQuXEJ6X3K1dF";
export var mcpContractItemMetric = "mcp-contract-item__metric_A2rBrhuxSl0y58jRPBnz";
export var mcpContractItemMetrics = "mcp-contract-item__metrics_kfnHGzm8ny1ttAE3plWZ";